<template>
  <div style="padding-top: 50px; padding-right:50px;">
    <v-card style="padding-top: 50px;">
      <v-layout wrap style="width:100%; padding: 0 50px;">
        <v-flex xs4>
          <span class="tableTitle">{{title}} </span>
        </v-flex>
        <v-flex xs8 style="text-align:right;">
          <incidents-search
            :onSearch="handleSearchPlayer"
            :searchResult="searchResult"
          />
          <!-- <v-btn style="border-radius: 20px;margin-right:20px;margin-top:-10px">
            <v-icon>mdi-magnify</v-icon>
          </v-btn> -->
          <!-- <v-icon style="margin-left: 15px;color: #90A4AE;" @click="onFilterError">mdi-alert-box</v-icon><v-icon style="margin-left: 15px;color: #90A4AE;" @click="onNetworkError">mdi-close-network</v-icon><v-icon style="margin-left: 15px;color: #90A4AE;" @click="onDownloadError">mdi-download-network</v-icon> -->
          <v-btn-toggle
            v-model="filterError"
            dense
            style="border-radius: 20px;"
          >
            <v-btn>
              <v-icon>mdi-alert-box</v-icon>
            </v-btn>

            <v-btn>
              <v-icon>mdi-close-network</v-icon>
            </v-btn>

            <v-btn>
              <v-icon>mdi-download-network</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-btn-toggle
            v-model="filterDescription"
            dense
            style="border-radius: 20px;margin-left:20px;"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <v-icon>mdi-table-of-contents</v-icon> PI
                </v-btn>
              </template>
              <span>_PI_</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <v-icon>mdi-table-of-contents</v-icon> TC
                </v-btn>
              </template>
              <span>_TC_</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <v-icon>mdi-table-of-contents</v-icon> RC
                </v-btn>
              </template>
              <span>_RC_</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <v-icon>mdi-table-of-contents</v-icon> VI
                </v-btn>
              </template>
              <span>_VI_</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <v-icon>mdi-table-of-contents</v-icon> T0
                </v-btn>
              </template>
              <span>_T0_</span>
            </v-tooltip>
            <v-btn color="#90A4AE">
              <v-icon color="white">mdi-table-of-contents</v-icon> <span style="color:white">NS</span>
            </v-btn>
            <v-btn color="#90A4AE">
              <v-icon color="white">mdi-table-of-contents</v-icon> <span style="color:white">GE</span>
            </v-btn>
            <!-- <v-btn>
              <v-icon>mdi-table-of-contents</v-icon> PI
            </v-btn>

            <v-btn>
              <v-icon>mdi-table-of-contents</v-icon> TC
            </v-btn>

            <v-btn>
              <v-icon>mdi-table-of-contents</v-icon> RC
            </v-btn>

            <v-btn>
              <v-icon>mdi-table-of-contents</v-icon> NS
            </v-btn>
            <v-btn>
              <v-icon>mdi-table-of-contents</v-icon> VI
            </v-btn>
            <v-btn>
              <v-icon>mdi-table-of-contents</v-icon> GE
            </v-btn> -->
          </v-btn-toggle>
        </v-flex>
      </v-layout>
      <div style="margin-top:20px;overflow-y: scroll;height: 815px">
      <v-data-table
        style="margin-top: 0;margin-left:5px;margin-right:5px;"
        :headers="headers"
        :items="data"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:[`item.serial`]="{ item }">
          <!-- <span v-if="isDevelopment" @click="() => handleEditDescription(item.id)">{{ item.name }}</span> -->
          <description-form  :key="`inci_${item.serial}`" v-if="isEditDescription" :item="item" />
          <span v-else>{{ item.serial}}</span>
        </template>
        <template v-slot:[`item.network`]="{ item }">
          <v-chip style="width:100%" small :color="getColor(item.network)" dark><center style="width=100%">{{ item.network }}</center></v-chip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div style="width:80px">
          <v-icon :style="{ 'color' : item.status === 'Error' ? '#D32F2F' : '#7CB240'}">{{item.status === 'Error' ? 'mdi-alert-box' : 'mdi-checkbox-marked'}}</v-icon>
          <v-icon :style="{ 'color' : item.statusColor.color}">{{item.statusColor.icon}}</v-icon>
          <v-icon :style="{ 'color' : item.downloadError? '#D32F2F' : '#7CB240'}">mdi-download-network</v-icon>
          </div>
        </template>
        <template v-slot:[`item.lctime`]="{ item }">
          <div style="width:150px">
            {{convertTime(item.lctime)}}
          </div>
        </template>
        
      </v-data-table>
      </div>
    </v-card>
    <v-divider style="margin-bottom:50px"/>
  </div>
</template>

<script>
  import IncidentsSearch from './IncidentsSearch'
  import DescriptionForm from './DescriptionForm'
  import utils from '@/services/utils'
  export default {
    components: {
      IncidentsSearch,
      DescriptionForm
    },
    props: {
      devices: {
        type: Array,
        required: false,
        default: []
      },
      onChangeFilter: {
        type: Function,
        required: true
      },
      allDevices: {
        type: Array,
        required: false,
        default: []
      }
    },
    data () {
      return {
        title: 'Incidencias por fecha de prioridad',
        headers: [
          {
            text: 'Network',
            align: 'start',
            value: 'network',
          },
          { text: 'Unit ID', value: 'serial' },
          { text: 'Nombre', value: 'name' },
          { text: 'Grupo', value: 'group_name' },
          { text: 'Status', value: 'status', sortable: false },
          { text: 'Fecha / Hora ult con', value: 'lctime' },
        ],
        data: [],
        filterError: 0,
        filterDescription: null,
        searchResult: null
      }
    },
    computed: {
      isEditDescription () {
        return false//process.env.VUE_APP_ENV === 'development'
      },
    },
    watch: {
      devices (newValue) {
        this.data = newValue
      },
      filterError (newValue) {
        // if (this.filterError === newValue) return
        switch (newValue) {
          case 0:
            this.onChangeFilter(newValue, this.filterDescription)
            // this.onFilterError()
            break
          case 1:
            this.onChangeFilter(newValue, this.filterDescription)
            // this.onNetworkError()
            break
          case 2:
            this.onChangeFilter(newValue, this.filterDescription)
            // this.onDownloadError()
            break
          default:            
            this.onChangeFilter(null, this.filterDescription)
            break
        }
      },
      filterDescription (newValue) {
        switch (newValue) {
          case 0:
            this.title = 'Pendiente de instalacion'
            break
          case 1:
            this.title = 'Cerrado temporalmente'
            break
          case 2:
            this.title = 'Pendiente de recuperar'
            break
          case 3:
            this.title = 'Listado general de visionado'
            break
          case 4:
            this.title = 'TRALINK CERO'
            break
          case 5:
            this.title = 'Pendiente de asignar licencia'
            break
          case 6:
            this.title = 'Listado general de players'
            break
          default:
            this.title = 'Incidencias por fecha de prioridad'
            break
        }
        if(this.filterDescription === 4 || this.filterDescription === 6) {
          this.headers[5].text = 'Descripción'
          this.headers[5].value = 'description'          
        } else {
          this.headers[5].text = 'Fecha / Hora ult con'
          this.headers[5].value = 'lctime'  
        }
        this.filterError = null
        this.onChangeFilter(null, newValue)
      }
    },
    mounted () {
      if (this.devices) this.data = this.devices
    },
    methods: {
      getColor (value) {
        return utils.getColor(value)
      },
      getStatus (value) {
        return utils.getStatus(value)
      },
      getDownloadStatus (value) {
        return utils.getDownloadStatus(value)
      },
      convertTime(value) {
        const dt = new Date(value)
        const result = `${
                dt.getDate().toString().padStart(2, '0')}/${
                (dt.getMonth()+1).toString().padStart(2, '0')}/${
                dt.getFullYear().toString().padStart(4, '0')} ${
                dt.getHours().toString().padStart(2, '0')}:${
                dt.getMinutes().toString().padStart(2, '0')}:${
                dt.getSeconds().toString().padStart(2, '0')}`

        return result === '01/01/0001 00:00:00' ? '' : result
      },
      handleSearchPlayer (value) {
        this.searchResult = this.allDevices.filter(x=>
          x.serial.toUpperCase().indexOf(value.toUpperCase()) >= 0
          || x.name.toUpperCase().indexOf(value.toUpperCase()) >= 0
          || x.group_name.toUpperCase().indexOf(value.toUpperCase()) >= 0
        )
      },
    },
  }
</script>
<style scoped>
  .tableTitle {
    color: #90A4AE;
    font-size: 25px;
  }
</style>
